import React from 'react';
import { BookOpen } from 'lucide-react';

const RotatedBookIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      style={{
        transform: 'rotate(90deg) translateX(1px)',
        transformOrigin: 'center center',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      {...props}
    >
      <BookOpen size={size} />
    </div>
  );
};

export default RotatedBookIcon;